<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">通讯录</a></li>
                <li><a href="#">批量导入</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>批量导入</span></div>
            <div class="formtext">导入文件有一定的格式规范，样例为: <a href="//file.2office.cn/csvsample.csv">Excel样例</a> , <a href="//file.2office.cn/vcardsample.vcf">Vcard样例</a> </div>
            <ul class="forminfo">
    
                <li><label>分组选择</label>
                <div class="vocation">
                    <el-select v-model="txlGroupValue" placeholder="请选择">
                        <el-option
                        v-for="item in txlGroupList"
                        :key="item.groupid"
                        :label="item.groupname"
                        :value="item.groupid">
                        </el-option>
                    </el-select>
                </div>
                    <el-upload
                        class="upload-demo"
                        :on-success="uploadSuccess"
                        ref="upload"
                        :action=uploadUrl
                        :before-upload="beforeAvatarUpload"
                        :on-change="txlFileChange"
                        :auto-upload="false"
                        :limit="1"
                        accept=".csv,.vcf,.xls" 
                        :show-file-list="true"
                        :data="fileUploadParams"
                        :headers="uploadHeaders"
                        :on-exceed="handleTxlExceed">
                        <el-button size="small" type="primary" round>选取文件</el-button>
                    </el-upload>
                </li>
                
                <li><label>&nbsp;</label><input name="" type="button" class="btn" @click="submitUpload" value="上传文件"/></li>
                
            </ul>
        </div>
        <div class="tools lh33">
            <b style="padding: 0 20px;"><!--"二办信使" 短信到达通知振铃号码调整为：057156896999--> 已上传的文件</b>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;" @click="refresh()">刷新日志</el-button>
        </div>
        <div id="usual1" class="usual">  
            <div class="formbody">            
            <table class="tablelist" style="border-collapse:collapse;table-layout:fixed;">
                <thead>
                <tr>
                    <th width="20%">上传时间</th>
                    <th width="30%">文件名称</th>
                    <th width="10%">上传成功的条数</th>
                    <th width="40%">反馈</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in list" :class="{odd:index%2!=0}">                    
                    <td width="20%" >{{item.createtime}}</td>
                    <td width="30%">{{item.srcfilename}}</td>
                    <td width="10%">{{item.successnum}}</td>
                    <td width="40%" >{{item.demo}}</td>
                </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="jian">&nbsp;</div>        
            </div> 

            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            //通讯录组
            txlGroupList:[],
            txlGroupValue:'',
            uploadUrl: this.GLOBAL.serverSrc + "/txl/uploadtxlfile.json",
            fileUploadParams:{'groupid':''},
            uploadHeaders:{'token':''},
            uploadips:'',
            fileList:[],
            list:[],
            pageIndex:0,
            totalCount:0,
            loadingShow:false,
        }
    },
    mounted(){
        // this.uploadHeaders.token = this.GLOBAL.token;
        this.getTxlGroupList();
        this.pageChange(1);
    },
    methods:{
        getTxlGroupList(){
            var that = this
            let data = {'groupid':''}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlgroup.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlGroupList = res.data.txlGroupList
                    if(null != that.txlGroupList && that.txlGroupList.length > 0)
                    {
                        that.txlGroupValue = that.txlGroupList[0].groupid;
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        handleTxlExceed() {
            this.$message.error("只能上传一份文件，修改请先删除。");
        },
        beforeAvatarUpload(file) {
            let Xls = file.name.split('.');
            if(Xls[1] === 'csv'||Xls[1] === 'vcf'){
                return file
            }else {
                this.$message.error('上传文件只能是 csv/vcf 格式!')
                return false;
            }
        },
        submitUpload(){
            if(this.txlGroupValue == '')
            {
                this.$message.error("请选择上传分组")
                return false;
            }
            this.fileUploadParams.groupid = this.txlGroupValue;
            this.uploadHeaders.token = this.GLOBAL.token
            this.$refs.upload.submit()
        },
        uploadSuccess(response) {
            if('0000000' == response.code)
            {
                alert("文件上传成功！");
                this.$refs.upload.clearFiles();
                this.pageChange(1);
            }
            else
            {
                alert(response.msg);
            }
        },
        txlFileChange(file) {
            
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/qrytxlcsvfilepage.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.list = res.data.list;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        refresh(){
            this.pageChange(1);
        },
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/txl/txlupload2.vue